import { get, post, request } from "@/utils/request";

// 待审核列表 https://www.showdoc.com.cn/1281067606385943?page_id=6457577045194858
export const userWaitApprove = get("/user/wait/approve");

// 审核通过 https://www.showdoc.com.cn/1281067606385943?page_id=6457600383849246
export const userCheckPass = post("/user/check/pass");

// 审核驳回 https://www.showdoc.com.cn/1281067606385943?page_id=6457597686016723
export const userCheckReject = post("/user/check/reject");

// 已注册用户列表 https://www.showdoc.com.cn/1281067606385943?page_id=6457888398115174
export const userRegisteredList = get("/user/registered/list");

// 冻结用户 https://www.showdoc.com.cn/1281067606385943?page_id=6457891524994839
export const userFreeze = post("/user/freeze");

// 取消冻结用户 https://www.showdoc.com.cn/1281067606385943?page_id=6469472752372431
export const userCancelFreeze = post("/user/cancel/freeze");

// 用户简单列表 https://www.showdoc.com.cn/1281067606385943?page_id=6467331775515410
export const userSimpleList = get("/user/simple/list");

// 我的问卷 https://www.showdoc.com.cn/1281067606385943?page_id=6467593609638110
export const userWorkbench = get("/user/workbench");

// 用户详情 https://www.showdoc.com.cn/1281067606385943?page_id=6457594495206753
export const userDetails = get("/user/details");

// 标签列表 https://www.showdoc.com.cn/1281067606385943?page_id=6464846924699230
export const userLabelList = get("/user/label/list");

// 新增标签 https://www.showdoc.com.cn/1281067606385943?page_id=6464864175570407
export const userAddLabel = get("/user/add/label");

// 新增标签 https://www.showdoc.com.cn/1281067606385943?page_id=6464864175570407
export const userSaveLabel = get("/user/save/label");

// 个人中心-修改信息 https://www.showdoc.com.cn/1281067606385943?page_id=6421961463956632
export const userUpdateInfo = post("/user/update/info");

// 用户验证 https://www.showdoc.com.cn/1281067606385943?page_id=6457634898708638
export const userVerification = post("/user/verification");

// 审核失败-修改用户信息 https://www.showdoc.com.cn/1281067606385943?page_id=6500002799941797
export const userUpdateRegisterInfo = post("/user/update/register/info");

// 我的报告 https://www.showdoc.com.cn/1281067606385943?page_id=6962561178670715
export const userReportList = get("/user/report/list");

// 报告详情 https://www.showdoc.com.cn/1281067606385943?page_id=6996265493412565
export const userReportDetails = get("/report/details");

// 报告范围数据集合 https://www.showdoc.com.cn/1281067606385943?page_id=6996353684989566
export const reportRangeDataList = (params) =>
  request("/report/range/data/list", params);
export const appointOrgRangeDataList = (params) =>
  request("/report/range/data/list/appointOrg", params);

// 我的诊断 https://www.showdoc.com.cn/1281067606385943?page_id=6962932869461942
export const userDiagnoseList = get("/user/diagnose/list");

// 报告诊断 https://www.showdoc.com.cn/1281067606385943?page_id=6910258266737760
export const reportDiagnoseReport = get("/report/diagnose/report");

// 专家用户简单列表 https://www.showdoc.com.cn/1281067606385943?page_id=6890569964514900
export const userSimpleExpertList = get("/user/simple/expert/list");

// 管理员用户列表 https://www.showdoc.com.cn/1281067606385943/7150528311657859
export const userManagerList = get("/user/manager/list");

// 创建管理员 https://www.showdoc.com.cn/1281067606385943/7150592111757124
export const userAddManager = post("/user/add/manager");

// 删除管理员 https://www.showdoc.com.cn/1281067606385943/7151043776764543
export const userDelManager = post("/user/del/manager");

// 专家用户列表 https://www.showdoc.com.cn/1281067606385943/7310535350497349
export const userExpertList = get("/user/expert/list");

// 创建专家 https://www.showdoc.com.cn/1281067606385943/7310537271251768
export const userAddExpert = post("/user/add/expert");

// 删除专家 https://www.showdoc.com.cn/1281067606385943/7310551603771382
export const userDelExpert = post("/user/del/expert");

// 导入答案 https://www.showdoc.com.cn/1281067606385943/7372204270808684
export const userImportOrg = post("/user/import/org");

// 修改行业信息
export const updateIndustry = post("/user/industry/update");

// 修改用户角色信息
export const updateUserRole = post("/user/update/userRole");

// 解锁
export const unlock = post("/user/unlock/");

// 所有用户列表
export const allUserList = get("/user/all/list");

// 修改用户信息
export const updateOne = post("/user/updateOne");

// 管理员修改用户密码
export const editPwd = post("/user/manage/editPwd");

// 埋点统计
export const accessAdd = get("/access/add");

// 操作日志
export const loginRecordApi = get("/access/list");

//点击登录查看详情
export const recordDetail = get("/access/details");

//查询组织机构
export const organizationList = get("/user/orgInfoList");

//用户统计
export const userCountApi = get("/access/statistic");

//批量下载
export const batchDownFile = get("/question/export/userQuestionnaire");

// 导出全部
export const exportAllFile = get("/question/export/exportAll");
